var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCollapseIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4074_169991)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.4108 11.6862C12.4108 11.3547 12.6793 11.0862 13.0107 11.0862L18.0677 11.0862L16.6918 9.71043C16.4576 9.4762 16.4576 9.09613 16.6918 8.8619C16.9261 8.62767 17.3061 8.62767 17.5404 8.8619L19.9404 11.2619C20.1746 11.4961 20.1746 11.8762 19.9404 12.1104L17.5404 14.5105C17.3061 14.7447 16.9261 14.7447 16.6918 14.5105C16.4576 14.2762 16.4576 13.8962 16.6918 13.6619L18.0677 12.2861L13.0107 12.2861C12.6793 12.2861 12.4108 12.0176 12.4108 11.6862Z",
    fill: "#0265DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.68706 12.1104L5.08708 14.5105C5.32131 14.7447 5.70138 14.7447 5.93561 14.5105C6.16984 14.2762 6.16984 13.8962 5.93561 13.6619L4.55979 12.2861L9.61671 12.2861C9.78244 12.2861 9.93243 12.219 10.041 12.1104C10.1495 12.0019 10.2166 11.8519 10.2166 11.6862C10.2166 11.3547 9.94816 11.0862 9.61671 11.0862L4.55978 11.0862L5.9356 9.71043C6.16983 9.4762 6.16983 9.09613 5.9356 8.8619C5.70138 8.62767 5.3213 8.62767 5.08708 8.8619L2.68705 11.2619C2.45283 11.4961 2.45283 11.8762 2.68706 12.1104Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4074_169991"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "matrix(-0.707107 0.707107 0.707107 0.707107 11.3137 0.372559)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollapseIcon);
export default __webpack_public_path__ + "static/media/collapse-icon.e40b733850e6c83c13fcd346fb2e6595.svg";
export { ForwardRef as ReactComponent };